import * as React from "react";
import PageBlockFaq from "./PageBlockFaq";

const PageBlock = ({ data }) => {
  if (!data) {
    return '';
  }
  switch (data.type) {
    case 'FAQ':
      return <PageBlockFaq data={data} />
    default:
      break;
  }
  return ''
};

export default PageBlock;
